module.exports = __webpack_public_path__ + "static/media/wordsearch.08f1738f.png";